import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetDoctorDashboardTotalReward(params) {
  return await postRequest("analytics/engagement/rewards/total", params);
}
export async function serviceGetDoctorDashboardCity(params) {
  return await postRequest("analytics/city/enrollment", params);
}
export async function serviceGetDoctorDashboardReward(params) {
  return await postRequest("analytics/doctor/stats", params);
}
export async function serviceGetDoctorDashboardEnrollment(params) {
  return await postRequest("analytics/enrollment/modes", params);
}
export async function serviceGetDoctorDashboardDrop(params) {
  return await postRequest("analytics/doctor/enrollment/trend", params);
}
export async function serviceGetDoctorDashboardCityWise(params) {
  return await postRequest("analytics/city/trend", params);
}
export async function serviceGetDoctorDashboardDoctorWise(params) {
  return await postRequest("analytics/doctor/trend", params);
}
export async function serviceGetDoctorDashboardMedicineRefill(params) {
  return await postRequest("analytics/doctor/medicine/trend", params);
}
export async function serviceGetDoctorDashboardMedReminder(params) {
  return await postRequest("analytics/doctor/appointment/reminders", params);
}
export async function serviceGetDoctorDashboardTable(params) {
  return await postRequest("analytics/doctor/performance", params);
}
export async function serviceDoctorEnrollTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/enrollment/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceDoctorMedicineTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/medicine/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}